import axios from 'axios';
import axiosInstance from './AxiosService';

const SFTPService = {
  fetchSFTP: async () => {
    const response = await axiosInstance.get(`hr-sftp/`);
    return response.data;
  },

  fetchSFTPById: async (sftpId) => {
    const response = await axiosInstance.get(`hr-sftp/${sftpId}/`);
    return response.data;
},

  fetchAppSFTPById: async (appID) => {
    const response = await axiosInstance.get(`app-sftp/${appID}/`);
    return response.data;
  },

  createSFTP: async (sftpData) => {
    const response = await axiosInstance.post(`hr-sftp/`, sftpData);
    return response.data;
  }, 

  createAppSFTP: async (sftpData) => {
    const response = await axiosInstance.post(`app-sftp/`, sftpData);
    return response.data;
  }, 

  updateAppSFTP: async (sftpId, sftpData) => {
    const response = await axiosInstance.put(`app-sftp/${sftpId}/`, sftpData);
    return response.data;
  },

  updateSFTP: async (sftpId, sftpData) => {
    const response = await axiosInstance.put(`hr-sftp/${sftpId}/`, sftpData);
    return response.data;
  },

  deleteSFTP: async (sftpId) => {
    const response = await axiosInstance.delete(`hr-sftp/${sftpId}/`);
    return response.data;
  },

  testHRsftp: async (sftpdata) => {
    const response = await axiosInstance.post(`sftp/hrtest/`, sftpdata,);
    return response.data;

  },

  /**
   * Test an SFTP connection
   * @param {string} id The SFTP config ID
   * @param {string} password The password to use for testing
   * @param {boolean} verifyDirectory Whether to verify that the source directory exists
   */
  testSFTPConnection: async (id, password, verifyDirectory = false) => {
    try {
      const response = await axiosInstance.post(`hr-sftp/${id}/test-connection/`, {
        password: password,
        verify_directory: verifyDirectory
      });
      return response.data;
    } catch (error) {
      console.error('Error testing SFTP connection:', error);
      throw error;
    }
  },

  hrdataMapping: async (formData) => {
    const response = await axiosInstance.post(`hr-data-mapping/`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true, 
    });
    return response.data;
  },

  fetchHRDataImportLog: async () => {
    const response = await axiosInstance.get(`hr-data-mapping/`,);
    return response.data;
  },

  userdataMapping: async (formData) => {
    const response = await axiosInstance.post(`user-data-mapping/`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true, 
    });
    return response.data;
  },

  fetchAppDataImportLog: async (APP_NAME) => {
    try {
      const response = await axiosInstance.get(`app-users/joblog/${APP_NAME}/`);
      return response.data;
    } catch (error) {
      console.log(`Error deleting application with ID ${APP_NAME}: ${error.message}`);
    }
  },

  // HR Job Schedule methods
  fetchHRJobs: async () => {
    try {
      console.log('SFTP Service: Fetching HR jobs');
      const response = await axiosInstance.get('hr-job-schedule/');
      return response.data;
    } catch (error) {
      console.error('Error fetching HR jobs:', error);
      throw error;
    }
  },

  fetchHRJobById: async (jobId) => {
    try {
      console.log(`SFTP Service: Fetching HR job by ID: ${jobId}`);
      const response = await axiosInstance.get(`hr-job-schedule/${jobId}/`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching HR job with ID ${jobId}:`, error);
      throw error;
    }
  },

  createHRJob: async (jobData) => {
    try {
      console.log('SFTP Service: Creating HR job');
      const response = await axiosInstance.post('hr-job-schedule/', jobData);
      return response.data;
    } catch (error) {
      console.error('Error creating HR job:', error);
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'Failed to create HR job');
      }
      throw error;
    }
  },

  updateHRJob: async (jobId, jobData) => {
    try {
      console.log(`SFTP Service: Updating HR job with ID: ${jobId}`);
      const response = await axiosInstance.put(`hr-job-schedule/${jobId}/`, jobData);
      return response.data;
    } catch (error) {
      console.error(`Error updating HR job with ID ${jobId}:`, error);
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'Failed to update HR job');
      }
      throw error;
    }
  },

  deleteHRJob: async (jobId) => {
    try {
      console.log(`SFTP Service: Deleting HR job with ID: ${jobId}`);
      const response = await axiosInstance.delete(`hr-job-schedule/${jobId}/`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting HR job with ID ${jobId}:`, error);
      throw error;
    }
  },

  testHRJob: async (jobId, password) => {
    try {
      console.log(`SFTP Service: Testing HR job with ID: ${jobId}`);
      const response = await axiosInstance.post(`hr-job/${jobId}/test-job/`, { password });
      return response.data;
    } catch (error) {
      console.error(`Error testing HR job with ID ${jobId}:`, error);
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'Failed to test HR job');
      }
      throw error;
    }
  }
};

export default SFTPService;
